import { backdropClasses } from '@mui/material/Backdrop';
import { buttonClasses } from '@mui/material/Button';
import { dialogActionsClasses } from '@mui/material/DialogActions';
import { dialogContentClasses } from '@mui/material/DialogContent';
import FormLabel from '@mui/material/FormLabel';
import { paperClasses } from '@mui/material/Paper';
import {
  alpha,
  styled,
} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { typographyClasses } from '@mui/material/Typography';
import { Modal } from 'components/ui/modals/Modal/index.js';

export const StyledModal = styled(Modal)(({ theme }) => ({
  [`& .${backdropClasses.root}`]: {
    backgroundColor: alpha(theme.palette.common.black, 0.07),
  },
  [`& .${paperClasses.root}`]: {
    boxShadow: 'none',
    borderRadius: 6,
    backgroundColor: theme.palette.background.default,
    minWidth: 570,
    minHeight: 250,
    padding: '30px 100px',
    gap: 20,
    alignItems: 'center',
    textAlign: 'center',
    transition: 'none !important',
    maxWidth: 720,
  },
  [`& .${dialogContentClasses.root}`]: {
    padding: '0 24px 20px',
    overflow: 'initial',
    [`& .${typographyClasses.h3}`]: {
      fontSize: 21,
      lineHeight: '32px',
      fontWeight: 600,
      color: theme.palette.primary.dark,
    },
    [`& .${typographyClasses.subtitle1}`]: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: '17px',
      color: theme.palette.primary.main,
    },
  },
  [`& .${dialogActionsClasses.root} .${buttonClasses.root}`]: {
    minWidth: 85,
    flexShrink: 0,
  },
}));

export const WarningModalTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '22px',
  lineHeight: '32px',
  color: theme.palette.primary.dark,
  marginBottom: 20,
  whiteSpace: 'pre-line',
}));

export const WarningModalText = styled(Typography)({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '17px',
});

export const CheckBoxText = styled(FormLabel)({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '17px',
  paddingLeft: '10px',
  paddingRight: '35px',
  cursor: 'pointer',
});

export const WaringList = styled('ul')(() => ({
  margin: 0,
  padding: 0,
  marginTop: '8px',
  marginLeft: '16px',
}));

export const WarningElement = styled('li')(() => ({
  padding: '8px 0',
}));
